import { UserIcon } from "@heroicons/react/24/outline";
import { cn } from "../utls/utils";

interface AvatarProps {
  src?: string | null;
  alt?: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  fallbackText?: string;
}

const sizeClasses = {
  sm: "w-8 h-8 text-sm",
  md: "w-10 h-10 text-base",
  lg: "w-12 h-12 text-lg",
  xl: "w-16 h-16 text-xl",
};

export default function Avatar({
  src,
  alt = "User avatar",
  size = "md",
  className,
  fallbackText,
}: AvatarProps) {
  const sizeClass = sizeClasses[size];

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={cn("rounded-full object-cover", sizeClass, className)}
      />
    );
  }

  // Fallback to initials or icon
  if (fallbackText) {
    const initials = fallbackText
      .split(" ")
      .map((name) => name.charAt(0))
      .join("")
      .toUpperCase()
      .slice(0, 2);

    return (
      <div
        className={cn(
          "rounded-full bg-terracotta-500 text-white flex items-center justify-center font-medium",
          sizeClass,
          className
        )}
      >
        {initials}
      </div>
    );
  }

  // Default fallback icon
  return (
    <div
      className={cn(
        "rounded-full bg-gray-300 text-gray-600 flex items-center justify-center",
        sizeClass,
        className
      )}
    >
      <UserIcon className="w-1/2 h-1/2" />
    </div>
  );
}
